import { useNavigation } from "react-router-dom";

function ProgressBar() {
  const navigation = useNavigation();
  const loading = navigation.state === "loading";

  return (
    <progress
      className={`fixed progress progress-primary h-0.5 top-0 z-20 w-full ${
        loading ? "" : "hidden"
      }`}
    ></progress>
  );
}

export default ProgressBar;
